import React from 'react';
import styled, { css } from 'styled-components';
import { colors } from 'Constants';

// State
import { ApiStore } from 'Store';

function hexToRgb(hex, alpha) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? `rgba(
      ${parseInt(result[1], 16)},
      ${parseInt(result[2], 16)},
      ${parseInt(result[3], 16)},
      ${alpha || 1})`
    : undefined;
}

const Table = styled.table`
  border-collapse: collapse;
  tr > * {
    padding: 8px;
    ${props => props.center && css(`text-align: center;`)}
  }

  th {
    font-weight: normal;
    text-align: left;
  }

  tr:nth-child(1) {
    th:nth-child(1) {
      background-color: ${props => props.color1};
      color: ${colors.textOnAccent};
    }

    th:nth-child(3n + 2) {
      background-color: ${props => props.color2};
      color: ${colors.textOnAccent};
    }

    th:nth-child(3n + 3) {
      background-color: ${props => props.color3};
      color: ${colors.textOnAccent};
    }
    th:nth-child(3n + 4) {
      background-color: ${props => props.color4};
      color: ${colors.textOnAccent};
    }
  }

  .row:nth-child(even) {
    background-color: #e2f2f2;
  }

  tr {
    > td:nth-child(1) {
      background-color: ${props => hexToRgb(props.color1, 0.2)};
    }

    > td:nth-child(3n + 2) {
      background-color: ${props => hexToRgb(props.color2, 0.2)};
    }

    > td:nth-child(3n + 3) {
      background-color: ${props => hexToRgb(props.color3, 0.2)};
    }

    > td:nth-child(3n + 4) {
      background-color: ${props => hexToRgb(props.color4, 0.2)};
    }
  }
`;

export default () => {
  // TODO: Switch to Case when RRD sends consistently cased data
  const decodeHeader = header => {
    const map = {
      deductible: (
        <span>
          <b>Deductible</b>
        </span>
      ),
      preventive: (
        <span>
          <b>Preventive care</b>
          <br />
          (oral exams, teeth cleanings)
        </span>
      ),
      maximum: (
        <span>
          <b>Annual maximum</b>
        </span>
      ),
      basicCare: (
        <span>
          <b>Basic care</b>
          <br />
          (fillings)
        </span>
      ),
      majorCare: (
        <span>
          <b>Major care</b>
          <br />
          (crowns)
        </span>
      ),
      orthodontics: (
        <span>
          <b>Orthodontics</b>
          <br />
          (braces)
        </span>
      )
    };
    return map[header];
  };

  const rowIndexs = [
    'deductible',
    'preventive',
    'maximum',
    'basicCare',
    'majorCare',
    'orthodontics'
  ];

  const plans = ApiStore.get().dental?.dentalPlansChart?.planDentalChart;
  if (plans) {
    const headers = ['', ...plans.map(a => a.name)];

    return (
      <div style={{ overflowX: 'auto' }}>
        <p>Compare the plans</p>
        <Table
          border
          color1="#666666"
          color2={colors.accent}
          color3="#649b41"
          color4="#f15e3f"
        >
          <tbody>
            {[
              <tr key="headers">
                {headers.map((name, i) => (
                  <th key={i}>{name}</th>
                ))}
              </tr>
            ]}
            {rowIndexs.map(rowName => {
              return (
                <tr className="row" key={rowName}>
                  <td>{decodeHeader(rowName)}</td>
                  {plans.map((aplan, index) => {
                    return <td>{aplan[rowName]}</td>;
                  })}
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    );
  }
  return null;
};
